<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<QuotationSearchSection
				:query="q"
				:situations="situations"
				@search-quotations="searchQuotations($event)"
			/>
			<v-divider class="mt-4" />
			<div class="table-container mt-4">
				<v-data-table
					locale="ja-JP"
					:items="quotations"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openDialog(item)">
              <!-- TODO 一時的なため変更要 -->
							<td>{{ item.quotation_number }}</td>
							<td>{{ item.situation_i18n }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.customer_company.name }}</td>
							<td>{{ item.regular_customer_company.name }}</td>
							<td>{{ common.formatDate(item.quotation_submission_date) }}</td>
							<td>{{ common.formatDate(item.order_date) }}</td>
							<td>{{ item.confirmor.name }}</td>
							<td>{{ common.formatDate(item.confirmation.created_at) }}</td>
							<td>{{ item.approver.name }}</td>
							<td>{{ common.formatDate(item.approval.created_at) }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
		</CommonFlame>
		<QuotationShowDialog
			:dialog.sync="dialog"
			:selectedQuotation="selectedQuotation"
			@reload-index="fetchQuotations(q, pagination.current)"
		/>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import PaginationModule from "../../modules/PaginationModule.vue"
import QuotationShowDialog from "./components/QuotationShowDialog.vue"
import QuotationSearchSection from "./components/QuotationSearchSection.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		QuotationShowDialog,
		QuotationSearchSection,
	},
	data() {
		return {
			title: "見積書一覧",
			quotations: [],
			authority_flag: false,
			situations: [],
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				// TODO
			},
			selectedQuotation: null,
			dialog: false,
			common,
		}
	},

	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()
		this.fetchQuotations(this.q, page, true)
	},
	methods: {
		fetchQuotations(q, page, first_visit = false) {
			const headers = authenticate.setHeader()
			const params = { page, q, first_visit }
			axios
				.get("/erp/v1/quotations", {
					params,
					headers,
				})
				.then((response) => {
					this.quotations = response.data.quotations
					this.pagination = response.data.pagination
					// 初回のアクセスのみデータを取得する
					if (first_visit) {
						this.situations = response.data.situations
						this.authority_flag = response.data.authority_flag
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openDialog(item) {
			this.selectedQuotation = item
			this.dialog = true
		},
		getPage(page) {
			this.fetchQuotations(this.q, page)
			this.$router.push({
				name: this.$route.name,
				query: { page: page, ...this.q },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		searchQuotations(q) {
			this.q = q
			this.fetchQuotations(q, 1)
			this.$router.push({
				name: this.$route.name,
				query: { ...this.q, page: 1 },
			})
		},
		setQuery() {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}

function headers() {
	return [
		{
			text: "見積番号",
			value: "quotation_number",
			width: "120px",
		},
		{
			text: "確度",
			value: "situation_i18n",
			width: "120px",
		},
		{
			text: "案件名",
			value: "name",
			width: "200px",
		},
		{
			text: "向け先",
			value: "customer_company.name",
			width: "200px",
		},
		{
			text: "得意先",
			value: "regular_customer_company.name",
			width: "200px",
		},
		{
			text: "見積日",
			value: "quotation_submission_date",
			width: "150px",
		},
		{
			text: "受注日",
			value: "order_date",
			width: "150px",
		},
		{
			text: "確認者",
			value: "confirmor.name",
			width: "150px",
		},
		{
			text: "確認日",
			value: "confirmation.created_at",
			width: "150px",
		},
		{
			text: "承認者",
			value: "approver.name",
			width: "150px",
		},
		{
			text: "承認日",
			value: "approval.created_at",
			width: "150px",
		},
	]
}
</script>
